export const getImageBlurDataUrl = () =>
  "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAAAAAAAD/4QBaRXhpZgAATU0AKgAAAAgABAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAAExAAIAAAAeAAAAWodpAAQAAAABAAAAWgAAABIAAAAYAAAAcAAAAABvb29vb29vb29vb29vbw==";

export enum RouteEnum {
  MAIN = "/",
  TOOLS = "/tools",
  BLOG = "/blog",
}

export enum ApprovalStatusEnum {
  Approved = "approved",
  NotApproved = "not_approved",
  Waiting = "waiting",
}

export enum ReviewItemType {
  product = "Product",
  blog = "Blog",
  tools = "Tools",
  none = "none",
}
